<template>
  <b-card class="shadow atm-rounded card-container">
    <section class="p-4 d-flex flex-column justify-content-center align-items-center gap-4">
      <section class="d-flex flex-column justify-content-center align-items-center w-100">
        <h5 class="font-weight-bold">Assignment Activities to date</h5>
      </section>
      <section>
        <apexchart ref="apexchart" :options="chartOptions" :series="chartSeries"></apexchart>
      </section>
    </section>
    <template #footer>
      <span @click="goToTasklist" class="d-flex justify-content-center">
        Go to Task List
      </span>
    </template>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import {
  assignmentActivitiesStates,
  assignmentActivitiesStatesColors,
  donutChartResponsive,
  assignmentActivitiesNoProgress,
} from '@/dashboard/constants';

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    tasksToDate: Array,
  },
  data() {
    return {
      chartOptions: {
        colors: assignmentActivitiesStatesColors,
        chart: {
          type: 'donut',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
          },
          dropShadow: {
            enabled: false,
          },
          //The number of tasks per status is returned
          formatter: (val, opts) => {
            if (opts.w.config.series[opts.seriesIndex] === assignmentActivitiesNoProgress) return 0;
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        legend: {
          show: true,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            width: 0,
            height: 0,
          },
          //The status plus the percentage of the task is returned.
          formatter: (val, opts) => {
            let percentage = opts.w.globals.seriesPercent[opts.seriesIndex];
            const series = opts.w.config.series[opts.seriesIndex];

            if (isNaN(percentage) || series === assignmentActivitiesNoProgress) {
              percentage = 0;
            }

            return `${val} ${Math.floor(percentage)}%`;
          },
        },
        tooltip: {
          enabled: false,
        },
        responsive: donutChartResponsive,
      },
      chartSeries: Array(3).fill(assignmentActivitiesNoProgress),
      allStatesOfActivityAtZero: [0.1, 0.1, 0.1],
    };
  },
  methods: {
    processChartData() {
      let chartSeries = [];
      const labels = [];

      this.tasksToDate.forEach((item) => {
        if (assignmentActivitiesStates.includes(item.state)) {
          chartSeries.push(item.countTasks);
          labels.push(item.state);
        }
      });
      if (chartSeries.every((item) => item === 0)) {
        chartSeries = this.allStatesOfActivityAtZero;
      }
      this.chartSeries = chartSeries;
      this.chartOptions.labels = labels;
    },
    goToTasklist() {
      this.$router.push({ name: 'task' });
    },
  },
  watch: {
    tasksToDate: {
      handler(newVal) {
        if (newVal) this.processChartData();
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.card-container {
  & .card-footer {
    cursor: pointer;
    user-select: none;
    color: white;
    background: var(--color-main);
    border-radius: 0 0 10px 10px;
    font-weight: 600;
    text-transform: capitalize;
    &:hover {
      filter: brightness(0.9);
    }
  }
}
</style>
